/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ReportSchedulesScheduleIdDelete$Params {
  scheduleId: string;
}

export function reportSchedulesScheduleIdDelete(http: HttpClient, rootUrl: string, params: ReportSchedulesScheduleIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, reportSchedulesScheduleIdDelete.PATH, 'delete');
  if (params) {
    rb.path('scheduleId', params.scheduleId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

reportSchedulesScheduleIdDelete.PATH = '/report-schedules/{scheduleId}';
